/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';
import { Dialog } from '@material-ui/core';
import LoaderSm from 'core/ui/LoaderSm';
import ViewerContent from './ViewerContent';

const ModalDocumentViewer = ({
  contractKey,
  open,
  callback,
  close,
  document,
  userId,
  buttonColor,
  loadingContract,
}) => {
  return (
    <Dialog open={!!open} onClose={close} maxWidth="lg" fullWidth scroll="body">
      <LoaderSm center loading={loadingContract} />
      <ViewerContent
        contractKey={contractKey}
        callback={callback}
        document={document}
        userId={userId}
        buttonColor={buttonColor}
      />
    </Dialog>
  );
};

export default ModalDocumentViewer;
